import React from 'react';

interface SelectFieldProps {
  label: string;
  labelClassName?: string;
  value: string;
  options: { value: string; title: string }[];
  onChange: (value: string) => void;
  disabled?: boolean;
}

const SelectField: React.FC<SelectFieldProps> = ({
  label,
  labelClassName,
  value,
  options,
  onChange,
  disabled,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(event.target.value);
  };

  return (
    <div className="flex flex-col flex-1">
      <label
        htmlFor={label.toLowerCase().replace(' ', '-')}
        className={`${labelClassName ?? 'text-base leading-6 text-neutral-800 text-left'}`}
      >
        {label}
      </label>
      <select
        id={label.toLowerCase().replace(' ', '-')}
        value={value}
        onChange={handleChange}
        disabled={disabled}
        className={`py-2 pr-1.5 pl-3.5 bg-white rounded-lg border border-gray-300 border-solid text-base leading-6 text-neutral-800 ${disabled ? 'opacity-50' : 'opacity-70'}`}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.title}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectField;
